<div
  #statePreview
  [fullscreen]="fullscreenElement"
  (fullScreenChange)="onFullscreenChange($event)"
  class="state_editor">
  <div
    class="d-flex flex-row justify-content-between align-items-center border border-primary bg-light-blue rounded-1 bg-light p-2 text-uppercase"
    id="state-toolbar">
    <button
      (click)="addNewTransition()"
      *ngIf="!isCodeView"
      class="btn btn-sm d-flex justify-content-center align-items-center mx-1"
      [class.btn-primary]="!isCodeView"
      [class.btn-transparent]="!isCodeView">
      <i
        aria-hidden="true"
        class="fas fa-plus config-setting"
        ngbTooltip="Add new transition"></i>
    </button>
    <button
      (click)="toggleFullscreen()"
      class="btn btn-sm d-flex justify-content-center align-items-center btn-transparent mx-1"
      [ngbTooltip]="isFullscreen ? 'Exit Full Screen' : 'Full Screen'">
      <i
        aria-hidden="true"
        class="fas config-setting"
        [ngClass]="{
          'fa-expand': !isFullscreen,
          'fa-compress': isFullscreen
        }">
      </i>
    </button>
    <button
      (click)="handleZoomIn()"
      class="btn btn-sm btn-light d-flex justify-content-center align-items-center mx-1"
      ngbTooltip="Zoom In">
      <i aria-hidden="true" class="fas fa-search-plus"></i>
    </button>
    <button
      (click)="handleZoomOut()"
      class="btn btn-sm btn-light d-flex justify-content-center align-items-center mx-1"
      ngbTooltip="Zoom Out">
      <i aria-hidden="true" class="fas fa-search-minus"></i>
    </button>
    <button
      (click)="handleResetZoom()"
      class="btn btn-sm btn-light d-flex justify-content-center align-items-center mx-1"
      ngbTooltip="Reset View">
      <i aria-hidden="true" class="fas fa-undo"></i>
    </button>
    <button
      (click)="calculateLayout()"
      class="btn btn-sm d-flex justify-content-center align-items-center mx-1"
      [class.btn-primary]="isCodeView"
      [class.btn-transparent]="isCodeView">
      <i
        aria-hidden="true"
        class="fas fa-shapes config-setting"
        ngbTooltip="Tidy Up"></i>
    </button>
  </div>

  <irembogov-state-machine
    *ngIf="!isCodeView"
    [iremboWorkflow]="workflowCode"
    [isFullscreen]="isFullscreen"
    [zoomAction$]="zoomAction$"
    [updateLine]="updateLine"
    [recalculateAction$]="recalculateAction$"
    (updateIremboWorkflowEvent)="
      getUpdatedWorkflow($event)
    "></irembogov-state-machine>
</div>
